module.exports = __webpack_public_path__ + "static/media/main-logo.df3547a3.svg";